import React, { useState } from 'react'
import { useRef } from 'react'
import { Dropdown, DropdownButton, Nav, Navbar } from 'react-bootstrap'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
// import { useAdminInfo } from '../../context/AdminContextDetail'
import {
    candidatemanagement,
    editprofile,
    employermanagement,
    home,
    jobapplicationmanagement,
    jobopeningmanagement,
    signin
} from '../../Routes/routingConsts'
import Header from './Header/Header'
import Sidebar from './Sidebar/Sidebar'
import ScrollToTop from '../Layout/ScrollToTop'

const Layout = () => {

    const [childValue, setChildValue] = useState(true);

    return (
        <React.Fragment>
            {/* <div className="employee-dashboard"> */}
            <div className= {`employee-dashboard ${childValue === false ? 'active' : ''}`}>
                <div className="header-area">
                    <Header childValue={childValue} setChildValue={setChildValue} />
                </div>
                <div className="employdash-panel">
                    <div className="sidebarcontent-wholebox">
                        <Sidebar childValue={childValue} setChildValue={setChildValue} />
                        <ScrollToTop />
                        <Outlet />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Layout
